import React from 'react';
export default function SharedIcebreaker({question,round,voters,userId,onVote}) {
  const count=new Set(voters.map(String)).size;
  const voted=voters.some(id=>String(id)===String(userId));
  return <aside className="shared-icebreaker">
    <span className="icebreaker-eyebrow">✦ רולטת שאלות היכרות</span>
    <div className="icebreaker-window"><p key={round} className="icebreaker-result" aria-live="polite">{question}</p></div>
    <p className="icebreaker-vote-status" role="status"><bdi>{Math.min(count,2)}/2</bdi>{" הצביעו להחלפת השאלה. "}{voted?"ההצבעה שלכם נקלטה. ממתינים לצד השני.":voters.length?"הצד השני רוצה שאלה אחרת. מצטרפים להצבעה?":"כדי להחליף שאלה צריך שתי הצבעות."}</p>
    <button type="button" disabled={voted} onClick={onVote}>{voted?"הצבעתם · 1/2":"הצבעה לשאלה אחרת"}</button>
  </aside>;
}
